import React from 'react';

const PageDown = (extraStyles?: React.CSSProperties) => {
    return (
        <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" style={extraStyles}>
            <path d="M22.7986 -2.01232e-06L1.19858 -3.90065e-06C0.979892 0.000680818 0.765531 0.0609969 0.578571 0.17445C0.391611 0.287901 0.239132 0.450193 0.137548 0.643858C0.0359626 0.837522 -0.0108819 1.05523 0.00205758 1.27353C0.014997 1.49184 0.0872302 1.70249 0.210981 1.8828L11.011 17.4828C11.4586 18.1296 12.5362 18.1296 12.985 17.4828L23.785 1.8828C23.91 1.70287 23.9833 1.49212 23.9969 1.27344C24.0106 1.05477 23.964 0.836544 23.8624 0.642469C23.7607 0.448393 23.6078 0.285892 23.4202 0.172625C23.2327 0.0593566 23.0177 -0.000347223 22.7986 -2.01232e-06ZM11.9986 14.6916L3.48818 2.39999L20.509 2.4L11.9986 14.6916Z" fill="currentColor" />
        </svg>
    );
};

export default PageDown;
